import { Action, createReducer, on } from '@ngrx/store';

import * as CasefileActions from '@actions/management/casefile.actions';

import * as ConfigurationActions from '@actions/configuration.actions';
import { CasefileModel } from '@models/management/casefile.model';

export interface State {
    casefiles: CasefileModel[];
    currentCasefile: CasefileModel;
    error: string | null;
    loading: boolean;
    message: string | null
}

export const initialState: State = {
    casefiles: [],
    currentCasefile: null,
    error: null,
    loading: true,
    message: null
};


const configurationReducer = createReducer(
    initialState,
    //**************************** CaseFiles ************************************* */
    on(CasefileActions.searchCasefiles, (state) => ({ ...state, error: null, loading: true })),
    on(CasefileActions.searchCasefilesSuccess, (state, { casefiles }) => ({ ...state, loading: false, casefiles })),
    on(CasefileActions.historicalCaseFile, (state) => ({ ...state, error: null, loading: true })),
    on(CasefileActions.historicalCaseFileSuccess, (state, { casefiles }) => ({ ...state, loading: false, casefiles })),
    on(CasefileActions.createCasefile, (state) => updateFlags(state)),
    on(CasefileActions.createCasefileSuccess, (state, { casefile }) => ({
        ...state,
        loading: false,
        message: "Disposicion creada correctamente...",
        Casefile: [...state.casefiles, casefile]
    })),
    on(CasefileActions.updateCasefile, (state) => updateFlags(state)),
    on(CasefileActions.updateCasefileSuccess, (state, { casefile }) => {
        const filter = state
            .casefiles
            .filter(item => item.RowKey !== casefile.RowKey)
        return {
            ...state,
            loading: false,
            message: "Disposicion actualizada correctamente...",
            dispositions: [...filter, casefile],
            currentCasefile: null,
        }
    }),
    on(CasefileActions.deleteCasefile, (state) => deleteFlags(state)),
    on(CasefileActions.deleteCasefileSuccess, (state, { Casefile }) => {
        const filter = state
            .casefiles
            .filter(item => item.RowKey !== Casefile.RowKey)
        return {
            ...state,
            loading: false,
            message: "Tipo de organización eliminado correctamente...",
            Casefiles: [...filter, Casefile],
            currentCasefile: null,
        }
    }),
    on(CasefileActions.selectCasefile, (state, { casefile }) => ({
        ...state,
        currentCasefile: casefile
    })),

   
);

//********************************************************************************************************** */
const updateFlags = (state: State): State => {
    return {
        ...state,
        error: null,
        loading: true,
        message: null
    }
}
const deleteFlags = (state: State): State => {
    return {
        ...state,
        error: null,
        loading: true,
        message: null
    }
}

export function reducer(state: State | undefined, action: Action) {
    return configurationReducer(state, action);
}


export const getCaseFile = (state: State) => state.casefiles;
export const getCurrentCasefile = (state: State) => state.currentCasefile;

export const getError = (state: State) => state.error;
export const getLoading = (state: State) => state.loading;
export const getMessageAction = (state: State) => state.message;
